import { useContext, type ReactNode } from "react";
import { StyleSheet, Text } from "react-native";

import { fonts, useThemedStyles, type ThemeColors } from "~/styles/theme";
import { ButtonContext } from "./button-context";

export function ButtonText({
  children,
  tone,
}: {
  children: ReactNode;
  tone?: "default" | "danger" | "light";
}) {
  const stylesheet = useThemedStyles(makeStyles);
  const variant = useContext(ButtonContext);
  const style =
    tone === "danger" || variant === "danger"
      ? stylesheet.danger
      : tone === "light" || variant === "primary"
        ? stylesheet.light
        : variant === "link"
          ? stylesheet.link
          : stylesheet.default;
  return <Text style={style}>{children}</Text>;
}

const makeStyles = (colors: ThemeColors) =>
  StyleSheet.create({
    default: {
      color: colors.foreground,
      fontFamily: fonts.medium,
      fontSize: 14,
    },
    light: {
      color: colors.primaryForeground,
      fontFamily: fonts.semibold,
      fontSize: 14,
    },
    link: {
      color: colors.primary,
      fontFamily: fonts.medium,
      fontSize: 14,
    },
    danger: {
      color: colors.danger,
      fontFamily: fonts.medium,
      fontSize: 14,
    },
  });
